"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Form/Controllers/TeamPickerController/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reacthookform = require('react-hook-form');




var _event = require('shared/services/event');



var _GenericSelect = require('web/components/Form/GenericSelect');
var _TeamOption = require('./TeamOption'); var _TeamOption2 = _interopRequireDefault(_TeamOption);










// The form's team can be missing from the map: teams still loading, or the
// team removed (BLOOMTEXT-WEB-1ZB). The picker then shows no selection.
const keyExtractor = (e) => _nullishCoalesce(_optionalChain([e, 'optionalAccess', _ => _.wrappedEntity, 'access', _2 => _2.TeamKey]), () => ( ''))

const MaybeTeamOption = ({ option, ...props }) => {
  if (option) return _react2.default.createElement(_TeamOption2.default, { option: option, ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}} )
  if (!props.isPreviewOption) return null

  return (
    _react2.default.createElement(_GenericSelect.GenericEntityOption, { isEmpty: true, onSelect: props.onSelect, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}, "Pick a team"

    )
  )
}

const TeamPickerController = ({
  name,
  control,
  teamsList,
  teamEntitiesMap,
}) => (
  _react2.default.createElement(_reacthookform.Controller, {
    name: name,
    control: control,
    render: 
      ({ field }) => (
        _react2.default.createElement(_GenericSelect.GenericSelect, {
          keyExtractor: keyExtractor,
          selectedOption: teamEntitiesMap[field.value ],
          options: teamsList,
          OptionComponent: MaybeTeamOption,
          onChange: s => field.onChange(_event.makeChangeEvent.call(void 0, keyExtractor(s))), __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}
        )
      )
    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}
  )
  )

exports. default = TeamPickerController
